import {
  faList,
  faPencilAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Modal from "../Modal/Modal";
import { EditMenuAPI, RemoveMenuSupplierAPI } from "../../Api/SupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import Style from "./SupplierMenuList.module.css";
import Input from "../Input/Input";
import Button from "../Button/Button";
const SupplierMenuList = ({ data, UpdateList }) => {
  let loadingHandler = null;
  const [purchased, setPurchased] = useState(false);
  const [categoryId, setCategoryId] = useState();
  const [title, setTitle] = useState("");
  const [EditCategory, setEditeCategory] = useState(false);

  const closeModalHandler = () => {
    setPurchased(false);
  };
  const ShowDetailHandler = (id) => {
    setEditeCategory(false);
    setPurchased(true);
    setCategoryId(id);
  };
  const ShowDetailHandler2 = (id, name) => {
    setEditeCategory(true);
    setPurchased(true);
    setCategoryId(id);
    setTitle(name);
  };
  const DeleteBlockTime = () => {
    let info = {
      id: categoryId,
    };
    RemoveMenuSupplierAPI(info, res => {
      if (res.status === 1) {
        succToast("باموفقیت حذف گردید!");
        closeModalHandler();
        UpdateList();
      } else {
        errorToast(res.message);
      }
    });
  };
  const EditeCategoryHandler = () => {
    if (title === "") {
      errorToast("نام جدید را وارد کنید");
    } else {
      let updateinfo = {
        category: title,
        id: categoryId,
      };
      EditMenuAPI(updateinfo, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          setTitle("");
          closeModalHandler();
          UpdateList();
        } else {
          errorToast(succ.message);
        }
      });
    }
  };

  if (data === undefined) {
    loadingHandler = <LoadingComponet />;
  } else {
    loadingHandler = data.map((item) => {
      return (
        <li key={item.id} className={Style.EachTitle}>
          <p>{item.category}</p>
          <div className={Style.btnsHolder}>
            <button
              className={Style.removeBtn}
              onClick={() => ShowDetailHandler(item.id)}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
            <button
              className={Style.editBtn}
              onClick={() => ShowDetailHandler2(item.id, item.category)}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </button>
          </div>
        </li>
      );
    });
  }

  const deletDivison = (
    <div className={Style.ModalCheker}>
      <p>آیا از حذف اطمینان دارید؟</p>
      <div className={Style.AnswerHolder}>
        <p className={Style.YesAnswer} onClick={DeleteBlockTime}>
          بله
        </p>
        <p className={Style.NoAnswer} onClick={closeModalHandler}>
          خیر
        </p>
      </div>
    </div>
  );

  const editDivison = (
    <div className={Style.ModalCheker2}>
      <h4>لطفا نام جدید را واردکنید</h4>
      <Input
        value={title}
        placeholder={"تیتر دسته بندی..."}
        onChange={(e) => setTitle(e.target.value)}
      />
      <Button
        Value={"ثبت"}
        ClassBtn={"confirmBtn"}
        ClickHandler={EditeCategoryHandler}
      />
    </div>
  );

  return (
    <section className={Style.componentHolder}>
      <Modal show={purchased} modalClose={closeModalHandler} translate={-20}>
        {EditCategory ? editDivison : deletDivison}
      </Modal>
      <p className={Style.categoruName}>
        :دسته بندی خودرا مشخص کنید
        <FontAwesomeIcon icon={faList} />
      </p>
      <ul className={Style.MenuTitleHolder}>{loadingHandler}</ul>
    </section>
  );
};

export default SupplierMenuList;
